import { createBrowserHistory } from '@tanstack/react-router';

export const appHistory = createBrowserHistory();
